import { PureComponent, Fragment } from "react";
import { setCookie } from "/services/cookies-service";
import { componentStyles } from "./industry-selection-component.scss";
import IndustrySelectionFirstStepComponent from "./industry-selection-first-step/industry-selection-first-step-component";
import IndustrySelectionSecondStepComponent from "./industry-selection-second-step/industry-selection-second-step-component";
import {
  INDUSTRY_SELECTED,
  INDUSTRY_MANAGE_OPTION_CLICKED,
  INDUSTRY_NEXT_CLICKED
} from "/constants/bigbrain-event-types";
import { USER_SELECTED_CLUSTER_COOKIE, USER_SELECTED_INDUSTRY_COOKIE } from "/constants/cookies";
import { getIndustryOptionByValue, DEFAULT_CLUSTER } from "services/industries/industries-service";

const STEP2_HASH = "#step2";

export default class IndustrySelectionComponent extends PureComponent {
  constructor(props) {
    super(props);
    this.nextStep = this.nextStep.bind(this);
    this.onBrowserHashChangeEvent = this.onBrowserHashChangeEvent.bind(this);
    this.handleSelectIndustryChange = this.handleSelectIndustryChange.bind(this);
    this.onSelectOption = this.onSelectOption.bind(this);

    this.state = {
      firstStepCompleted: false,
      selectedIndustry: null,
      selectedManageOptions: []
    };
  }
  componentDidMount() {
    window.onhashchange = this.onBrowserHashChangeEvent;
  }

  handleSelectIndustryChange(selectedOption) {
    const value = selectedOption.value;
    BigBrain("track", INDUSTRY_SELECTED, { kind: value });
    this.setState({ selectedIndustry: value, selectedManageOptions: [] });
  }

  onSelectOption(option) {
    const { selectedManageOptions } = this.state;
    let newManageOptions;
    let selectedTextForEvent;
    if (selectedManageOptions.indexOf(option) > -1) {
      newManageOptions = selectedManageOptions.filter((selectedOption) => selectedOption != option);
      selectedTextForEvent = "removed";
    } else {
      newManageOptions = selectedManageOptions.concat(option);
      selectedTextForEvent = "selected";
    }
    BigBrain("track", INDUSTRY_MANAGE_OPTION_CLICKED, { kind: option, info1: selectedTextForEvent });

    this.setState({ selectedManageOptions: newManageOptions });
  }

  onBrowserHashChangeEvent() {
    const hash = window.location.hash;
    if (hash.length === 0) {
      this.setState({ firstStepCompleted: false });
    }
  }
  nextStep() {
    const { selectedIndustry, selectedManageOptions } = this.state;

    if (!window.location.hash) {
      window.location.href += STEP2_HASH;
    }
    const selectedOption = getIndustryOptionByValue(selectedIndustry);

    BigBrain("track", INDUSTRY_NEXT_CLICKED, { info1: selectedIndustry, info2: selectedManageOptions.join(",") });
    setCookie(USER_SELECTED_CLUSTER_COOKIE, selectedOption.clusterId || DEFAULT_CLUSTER);
    setCookie(USER_SELECTED_INDUSTRY_COOKIE, selectedIndustry);

    this.setState({ firstStepCompleted: true });
  }

  render() {
    const { firstStepCompleted, selectedIndustry, selectedManageOptions } = this.state;

    return (
      <div className="industry-selection-wrapper">
        {!firstStepCompleted && (
          <IndustrySelectionFirstStepComponent
            nextStepCallback={this.nextStep}
            selectedIndustry={selectedIndustry}
            selectedManageOptions={selectedManageOptions}
            handleSelectIndustryChange={this.handleSelectIndustryChange}
            handleOptionsSelected={this.onSelectOption}
          />
        )}

        {firstStepCompleted && <IndustrySelectionSecondStepComponent />}

        <style jsx>{componentStyles}</style>
      </div>
    );
  }
}
